import { ProductContactHelper } from '..';

export const useProductContact = () => {
	let productContactHelper = new ProductContactHelper();
	return {
		productContactHelper,
		activeProductContact: productContactHelper.active()
	};
};
